// @flow
import React, { Fragment, cloneElement, type Element } from 'react';
import { StylesProvider } from '@material-ui/styles';
import styled from 'styled-components';
import { colors } from '../../constants';
import XIcon from '../../icons/xicon';
import useModal from '../modals/use_modal';
import { StyledDialog, StyledDialogContent } from '../modals/shared';
import DefaultTheme from '../modals/default_theme';

const ModalContainer = (props: any) => {
  const {
    children,
    open,
    closeModal,
    fullScreen,
    fullWidth,
    maxWidth,
    width,
    onClose,
    modalProps,
    id,
    ariaLabelledBy,
    ariaDescribedBy,
    className,
  } = props;

  if (fullScreen) {
    console.warn(
      'FULL SCREEN MODAL - Please do not use this modal yet. The design/styling of the full screen modal is still in progress.'
    );
  }
  return (
    <DefaultTheme>
      <StyledDialog
        open={open}
        onClose={closeModal}
        onExit={onClose}
        fullScreen={fullScreen}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        width={width}
        className={className}
        id={id}
        aria-labelledby={ariaLabelledBy || 'modal_title'}
        aria-describedby={ariaDescribedBy}
        {...modalProps}
      >
        {children}
      </StyledDialog>
    </DefaultTheme>
  );
};

type Props = {
  modalContent: Element<any>,
  children: Element<any>,
  onClose?: Function,
  open?: boolean,
};

export default function HeadlessModal(props: Props) {
  const [open, openModal, closeModal] = useModal(props.open || false);
  const { children, modalContent } = props;
  const onClose = () => {
    if (props.onClose) {
      props.onClose();
    }
    closeModal();
  };

  return (
    <Fragment>
      {cloneElement(children, {
        onClick: openModal,
      })}

      <StylesProvider injectFirst>
        <ModalContainer
          {...props}
          open={open}
          closeModal={onClose}
          maxWidth="xl"
        >
          <RestyledStyledDialogContent dividers>
            <Close onClick={onClose}>
              <CloseIcon hoverColor={colors.mediumGrey} size="2rem" />
            </Close>
            {modalContent}
          </RestyledStyledDialogContent>
        </ModalContainer>
      </StylesProvider>
    </Fragment>
  );
}

const Close = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  border: 0.0625rem solid transparent;
  transition: background-color 100ms linear, border 100ms linear;
  text-align: center;

  &:hover {
    background-color: ${colors.lighterGrey};
    border: 0.0625rem solid ${colors.lighterGrey};
  }
`;

const CloseIcon = styled(XIcon)`
  padding-top: 0.25rem;
`;

const RestyledStyledDialogContent = styled(StyledDialogContent)`
  && {
    overflow: hidden;
    padding: 2rem;
  }
`;
